module.exports = __webpack_public_path__ + "images/bookmark@3x.png?67845a63";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookmark@3x.png
// module id = 608
// module chunks = 7